<script setup>
import { ref, onMounted, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router'
/* import {ChartTypeEnum} from  "@/components/explorer/visualizations/ChartTypeEnum.js" */
/* import ToggleSwitch from '@/components/common/ToggleSwitch.vue'; */
import DropDown from "@/components/common/DropDownSelect.vue"

//properties set by parent
const props = defineProps({
	indicator: {
		type: Object,
		required: true,
	},
	categories: {
		type: Array,
		required: true
	},
	chartSettings: {
		type: Object,
		required: true
	}
}) 

//componenet methods exposed to parent


//events raised by component
const emit = defineEmits(["openFilters","updateChartType", "updateChartCategory"])

//reactive field proxies
/* const toggleHorizontalBar = ref(props.chartSettings.toggleHorizontalBar) */
/* const toggleStack = ref(props.chartSettings.toggleStack) */
const selectedXAxisCatName = ref('')
const selectedGrpCatName = ref('')
const xAxisCategories = ref([])
const xGrpCategories = ref([])

//local variables
let chartOptions = {}
let AllCats = []
let AllGrpCats = []
let chartSettings = null
const router = useRouter()
let xAxisExcludeList = []
let grpExcludeList = []


function setupFilters() {
	emit('openFilters');
}

function updateXaxis(catName) {
	console.log('updateXaxis')

	//let chartSettings = {...props.chartSettings}
	let chartSettings = props.chartSettings
	let xAxisDim = xAxisCategories.value.find(i => i.columnName == catName)
	selectedXAxisCatName.value = catName
	buildXAxisExcludeList()
	buildGrpExcludeList()	
	chartSettings.xAxisDim = xAxisDim
	emit('updateChartCategory', chartSettings);
}

function updateGroup(catName) {
	//let chartSettings = {...props.chartSettings}
	let chartSettings = props.chartSettings
	let seriesDim = xGrpCategories.value.find(i => i.columnName == catName)
	selectedGrpCatName.value = catName
	buildXAxisExcludeList()
	buildGrpExcludeList()	
	//set xaxis series (or group) dim
	chartSettings.seriesDim = seriesDim
	emit('updateChartCategory', chartSettings);
}

onMounted(() => {

	if(props.chartSettings && props.chartSettings.xAxisDim) {
		selectedXAxisCatName.value = props.chartSettings.xAxisDim.columnName
		selectedGrpCatName.value = props.chartSettings.seriesDim.columnName			
		AllCats = props.categories.filter(cat => { 
			if(cat.treemapFlag == 1 && cat.columnName !== 'Year' && cat.childColumnName == null) {
				return cat
			}
		})
		AllGrpCats = props.categories.filter(cat => {			
			if(cat.categoryLabelFlag == 1 && cat.columnName !== 'Year' && cat.childColumnName == null) {
				return cat
			}
		})
	
		xAxisCategories.value = AllCats
		xGrpCategories.value = AllGrpCats		
		buildXAxisExcludeList()
		buildGrpExcludeList()		
	}

	watch(props, (newProps) => {
		selectedXAxisCatName.value = newProps.chartSettings.xAxisDim.columnName
		selectedGrpCatName.value = newProps.chartSettings.seriesDim.columnName				
		AllCats = newProps.categories.filter(cat => { 
			if(cat.treemapFlag == 1 && cat.columnName !== 'Year' && cat.childColumnName == null) {
				return cat
			}
		})
		AllGrpCats = newProps.categories.filter(cat => {			
			if(cat.categoryLabelFlag == 1 && cat.columnName !== 'Year' && cat.childColumnName == null) {
				return cat
			}
		})	
		xAxisCategories.value = AllCats
		xGrpCategories.value = AllGrpCats			
		buildXAxisExcludeList()
		buildGrpExcludeList()

	})	
});

function buildXAxisExcludeList() {
	//Do not allow XAxisCat to be child of GrpCat
	xAxisExcludeList = AllCats.filter(cat => {
		if(cat.columnName == selectedGrpCatName.value || cat.columnName == 'Year' ||
		(cat.childColumnName != null && cat.childColumnName == selectedGrpCatName.value)||
		(cat.parentColumnName != null && cat.parentColumnName == selectedGrpCatName.value)) {
			return true;
		}
	}).map(item => item.columnName)


}
function buildGrpExcludeList() {
	//Do not allow GrpCat to be a parent of XAxisCat
	grpExcludeList = AllGrpCats.filter(cat => {
		if(cat.columnName == selectedXAxisCatName.value ||!cat.treemapFlag || cat.columnName == 'Year' ||  
		(cat.parentColumnName != null && cat.parentColumnName == selectedXAxisCatName.value)||
		(cat.childColumnName != null && cat.childColumnName == selectedXAxisCatName.value)) {
			return true;
		}
	}).map(item => item.columnName)	
}

</script>

<template>
	<div class="chart-options">

		<div class="chart-options-row">
			<div class="chart-options-col">
				<div>
					<div class="subtle-label">Category</div>
				</div>
				<div>
					<DropDown v-model="selectedGrpCatName" :list="xGrpCategories" :keyField="'columnName'" @selectedDropdown="updateGroup" :disableFields="grpExcludeList" />				
				</div>
			</div>

			<div class="chart-options-col">
				<div>
					<div class="subtle-label">Detail</div>
				</div>
				<div>
					<DropDown v-model="selectedXAxisCatName" :list="xAxisCategories" :keyField="'columnName'" @selectedDropdown="updateXaxis"  :disableFields="xAxisExcludeList" />
				</div>
			</div>
			<div class="chart-options-col bottom">
				<button @click="setupFilters" class="btn-tertiary"><span class="icon-settings">
					<i class="fa-regular fa-sliders"></i></span>Customize chart</button>
			</div>
		</div>
	</div>
</template>

<style scoped>
.chart-options {
	display:flex;
	flex-direction: row;
	justify-content:space-between;
	margin: 0 1.25rem 0.25rem 1.25rem;	
}

.chart-options-row {
	display:flex;
	flex-direction: row;
	column-gap: var(--spacing-lg);
}

.chart-options-row.end {
	display:flex;
	justify-content: end;
	margin-right: 1.25rem;
    height: 4rem;
    padding-top: 1.5rem;	
}

.chart-options-col {
	display: flex;
	flex-direction: column;
	justify-content: start;
}
.chart-options-col.bottom {
	justify-content: end;
	align-items: start;
	width: 100%;
}

.btn-tertiary {
	padding: 0 0.25rem;
	height: 2.5rem;
	white-space: nowrap;
}

.category-hide {
	display: none;
}

.bar-chart-control {
	display: flex;
	align-items: center;
}

.toggle-label {
	color: var(--text-Secondary);
	font-family: var(--font-family-Title);
	font-weight: var(--font-weight-Medium);
	font-size: var(--font-size-Base);
	padding-right: .5rem;
	padding-left: 1.5rem;
}

.icon-settings {
	color: var(--icon-cta-Blue);
	margin-right:.5rem;
}

/* 1023px - iPad */
@media (max-width: 63.9375rem) {
	.chart-options {
		flex-wrap: wrap;
        align-content: space-between;
        height: 7.5rem;		
	}

	.chart-options > div {
		flex: 1 1 50%;
	}

	.chart-options-row.end {
		justify-content: start;
	}

	.bar-chart-control label{
		padding-left: 0;
	}
}

/* 767px - mobile */
@media (max-width: 47.9375rem) {
	.chart-options {
        height: 14rem;		
	}

	.chart-options-row {
		flex-wrap: wrap;
	}

	.chart-options-col {
		flex: 1 1 100%;
		padding-top: 1rem;
	}	
}
</style>